import { invariant } from '@e-socna/utils';

import { useMissionContextOptional } from '../../../contexts/MissionContext/hooks/useMissionContextOptional.hook';
import { MissionContextStatus } from '../../../contexts/MissionContext/types/mission-context.type';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useMissionTitre = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<string> => {
  const missionContext = useMissionContextOptional();

  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isSuccess: false,
      isLoading: false,
    };
  }

  invariant(!!missionContext, 'Mission context is required');

  const { status, mission } = missionContext;

  switch (status) {
    case MissionContextStatus.Error:
      return {
        data: undefined,
        error: new Error('Error loading mission context'),
        isSuccess: false,
        isLoading: false,
      };
    case MissionContextStatus.Loading:
      return {
        data: undefined,
        error: null,
        isSuccess: false,
        isLoading: true,
      };
    case MissionContextStatus.NotInitialized:
      return {
        data: undefined,
        error: new Error('Mission context not initialized'),
        isSuccess: false,
        isLoading: false,
      };
    case MissionContextStatus.Ready: {
      const {
        consolidation: { title },
      } = mission;

      if (!title) {
        return {
          data: undefined,
          error: new Error('Title is missing'),
          isSuccess: false,
          isLoading: false,
        };
      }

      return {
        data: {
          generated: title,
        },
        error: null,
        isSuccess: true,
        isLoading: false,
      };
    }
    default: {
      throw new Error('Unhandled mission context status');
    }
  }
};
